module.exports = __webpack_public_path__ + "static/img/(1959)_11_19_ViennaProgram.dd71314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/thumbs/(1959)_11_19_ViennaProgram.jpg
// module id = 0Kqx
// module chunks = 0